















































import { Component, Vue, Watch } from 'vue-property-decorator'
import EditorCustomize from '@/components/editorCustomize/index.vue'
import TopicApi from '@/api/shopMall/topic/index'
@Component({
  components: {
    EditorCustomize
  }
})
export default class EditTopic extends Vue {
  topicId = ''
  formData = {
    title: '',
    content: '',
    displayOrder: 0,
    includeInFooterColumn1: false,
    includeInFooterColumn2: false,
    includeInFooterColumn3: false,
    published: true
  }
  ruleValidate = {
    title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
    content: [{ required: true, message: '内容不能为空', trigger: 'blur' }]
  }
  mounted() {
    if (this.$route.params.id) {
      this.topicId = this.$route.params.id
      this.loadData()
    }
  }
  loadData() {
    TopicApi.get(this.topicId).then(res => {
      this.formData = res.data
    })
  }
  editorChange(e) {
    this.formData.content = e
  }
  save() {
    ;(this.$refs['formValidate'] as any).validate(valid => {
      if (valid) {
        if (this.topicId) {
          TopicApi.update(this.topicId, this.formData).then(res => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'pcTopic' })
          })
        } else {
          TopicApi.create(this.formData).then(res => {
            this.$Message.success('保存成功')
            this.$router.push({ name: 'pcTopic' })
          })
        }
      }
    })
  }
}
